/**
 * src/lib/api/knowledge-indexer.js — Client-side ChromaDB Knowledge Indexer
 *
 * Fire-and-forget indexer that sends project activity to ChromaDB
 * via the /api/agent teach endpoint (which proxies to Hetzner).
 *
 * Used by client-side modules (tasks.js, projects.js) where the
 * server-side knowledge-indexer.js is not available.
 */

import { getAuthHeaders, API_BASE } from './client';

/**
 * Index a knowledge item to ChromaDB via the agent teach endpoint.
 * Fire-and-forget — never throws, never blocks the caller.
 *
 * @param {string} text - The knowledge text to index
 * @param {string} topic - Topic/category for retrieval (usually project name)
 */
export function indexKnowledge(text, topic) {
  if (!text || text.length < 5) return;

  // Skip test/synthetic data
  if (text.includes('[TEST-E2E]')) return;

  getAuthHeaders()
    .then((auth) => {
      fetch(`${API_BASE}/ai`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...auth },
        body: JSON.stringify({
          action: 'agent.teach',
          text: `${text}\n\nTimestamp: ${new Date().toISOString()}`,
          topic: topic || 'General',
        }),
      }).catch(() => {});
    })
    .catch(() => {});
}
